import React from 'react';
import * as _ from "lodash";

import NavBtnWidget from '../NavBtnWidget.jsx'; 

import {InputWidget} from '../../controls/widgets.jsx';

import * as C from "../../controls/constraints.jsx";


export default ({schema, data, onDataChanged}) => {
    const
        onDataChangeEventHandler = (value, key) => {
            let diff = {};
            diff[key] = value;
            (onDataChanged || function(){})(diff);
        }

        return (
            <form className="form">
                <div className="card border-primary">
                    <div className="card-header text-bg-primary">Контакты</div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6">
                                <InputWidget
                                    type="tel"
                                    name="contact_phone"
                                    title="Контактный телефон:"
                                    placeholder="номер мобильного или городского телефона"
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                    validators={[
                                        new C.NotEmptyConstraint("Укажите номер телефона"),
                                        new C.ValidPhoneConstraint("Укажите корректный номер телефона")
                                    ]}
                                />
                            </div>
                            <div className="col-md-6">
                                <InputWidget
                                    type="tel"
                                    name="contact_phone_alt"
                                    title="Домашний телефон (при наличии):"
                                    placeholder="с кодом города, например (3412) 43-52-98"
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                    validators={[
                                        new C.ValidPhoneConstraint("Укажите корректный номер телефона")
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <InputWidget
                                    type="email"
                                    name="contact_email"
                                    title="Электронная почта:"
                                    placeholder="user@user.us"
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                />
                            </div>
                            <div className="col-md-6">
                                <InputWidget
                                    type="url"
                                    name="contact_social"
                                    title="Социальные сети:"
                                    placeholder="ссылка на личную страницу в соцсети"
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <NavBtnWidget to="/check_and_send" />

            </form>
        );
    }
